var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sidebar-table-wrap" },
    [
      _c(
        "app-custom-table",
        {
          staticClass: "sidebar-table",
          attrs: { cellpadding: "0", cellspacing: "0" },
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$ct("sidebar.product-prices.category"))),
              ]),
              _c("th", { staticClass: "amount" }, [
                _vm._v(_vm._s(_vm.$ct("sidebar.product-prices.excl-vat"))),
              ]),
              _c("th", { staticClass: "amount" }, [
                _vm._v(_vm._s(_vm.$ct("sidebar.product-prices.incl-vat"))),
              ]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.categories, function (cat) {
              return _c("tr", { key: cat.id }, [
                _c("td", [_vm._v(_vm._s(cat.name))]),
                _c("td", { staticClass: "amount" }, [_vm._v(_vm._s(cat.excl))]),
                _c("td", { staticClass: "amount" }, [_vm._v(_vm._s(cat.incl))]),
              ])
            }),
            0
          ),
          _vm.buyPrice !== null
            ? _c("tfoot", [
                _c("tr", [
                  _c("td", [
                    _vm._v(_vm._s(_vm.$ct("sidebar.product-prices.buy-price"))),
                  ]),
                  _c("td", { staticClass: "amount" }, [
                    _vm._v(_vm._s(_vm.buyPrice)),
                  ]),
                  _c("td"),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }